import './ContractPageForm.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { reduxForm, getFormSyncErrors, Form, hasSubmitFailed, submit } from 'redux-form';
import DynamicIframe from '../../../../../shared-components/DynamicIframe/DynamicIframe';
import _ from 'lodash';
import PopupLink from '../../../../../shared-components/PopupLink/PopupLink';
import StickyFooter from '../../../../../shared-components/StickyFooter/StickyFooter';
import Waypoint from 'react-waypoint';
import ContractCheckBox from '../../../../components/AgreeToContractCheckBox/AgreeToContractCheckBox';
import Button, {BUTTON_STYLE} from '../../../../../shared-components/Button/Button';
import { CREDIT_TYPE, CONTRACT_FORM_ID } from '../../../../../framework/App/AppConstants';
import { submitContractApi } from './ContractPageFormActions';
import { scrollToBottom } from '../../../../../GB/components/AgreementCheckbox/AgreementCheckboxUtils';

const LOCALE_PREFIX = 'DE/pages/ContractPage/ContractPage';

export class ContractPageForm extends Component {
    static propTypes = {
        formValues: PropTypes.object,
        formSyncErrors: PropTypes.object,
        creditType: PropTypes.string,
        hasSubmitFailed: PropTypes.bool,
        cart: PropTypes.shape({
            gross_total_amount: PropTypes.shape({
                value: PropTypes.string
            })
        }),
        onFormSubmit: PropTypes.func.isRequired,
        htmlContract: PropTypes.string.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        onClickContinue: PropTypes.func.isRequired,

        // Comes from injectIntl HOC
        intl: intlShape.isRequired,

        // Comes from reduxForm HOC
        dirty: PropTypes.bool, // Has form been touched
        submitting: PropTypes.bool // Redux inject this to indicate if the form submit is still in progress
    };

    static defaultProps = {
        hasSubmitFailed: false
    };

    constructor() {
        super();
        this.state = {
            fixToBottom: true
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const checkedPath = 'formValues.agreeToReadContract';
        const oldChecked = _.get(prevProps, checkedPath, false);
        const newChecked = _.get(this.props, checkedPath, false);
        if (oldChecked !== newChecked && newChecked === true) {
            scrollToBottom(window, 1000);
        }
    }

    handleWaypointEnter = () => this.setState({ fixToBottom: false });

    handleWaypointLeave = () => this.setState({ fixToBottom: true });

    showCAPrintPopup = () => {
        const cAWindow = window.open('about:blank', 'CreditContract', 'width=835, height=500, location=1, status=1, toolbar=0, menubar=0, resizable=1, scrollbars=1');
        cAWindow.focus();
        cAWindow.document.write(`<!DOCTYPE html>${this.props.htmlContract}`);
        cAWindow.print();
    };

    onFormSubmit = (formValues) => {
        const { onFormSubmit, intl } = this.props;
        return onFormSubmit(formValues, intl);
    };

    render() {
        const { handleSubmit, htmlContract, hasSubmitFailed,
            onClickContinue, intl, submitting } = this.props;
        const { fixToBottom } = this.state;

        return (
            <Form
                className="proceed"
                id="ContractPageForm"
                onSubmit={handleSubmit(this.onFormSubmit)}
            >
                <div id="creditContractVisibleContainer">
                    <div id="creditContractHeader">
                        <h2 className="alpha">{intl.formatMessage({ id: `${LOCALE_PREFIX}.approvedHeader` })}</h2>

                        <p className="primary print-content">
                            <span className="print-icon" />
                            <a href="#"
                                data-automation-id="print"
                                className="print-html-link"
                                name="print-html-link"
                                onClick={this.showCAPrintPopup}
                            >
                                {intl.formatMessage({ id: `${LOCALE_PREFIX}.printCopy` })}
                            </a>
                        </p>
                        <p className="primary print-content">
                            <span className="download-icon" />
                            <PopupLink
                                id="downloadContract"
                                url="creditContract"
                                className="pdfLink popup"
                                name="downloadContract"
                            >
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.contractPDF`}
                                />
                            </PopupLink>
                        </p>
                    </div>

                    <div className="outline-frame">
                        <div className="contract-fade" />
                        <div className="outline-body">
                            <DynamicIframe
                                htmlString={htmlContract}
                                autoHeight={true}
                                extraHeight={80}
                                className="credit-contract-iframe"
                            />
                        </div>
                    </div>

                    <StickyFooter fixToBottom={fixToBottom} fadedBackground={true}>
                        <div className="agree-credit">
                            <ContractCheckBox allowErrorPopout={hasSubmitFailed} />
                        </div>
                    </StickyFooter>
                    <Waypoint
                        onEnter={this.handleWaypointEnter}
                        onLeave={this.handleWaypointLeave}
                    />
                </div>
                <div className="deCredit-continueButton-wrapper paypal-contract-buttons">
                    <Button
                        data-automation-id="continue"
                        btnType="button"
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                        className="creditContractAgreeToTermsDE"
                        onClick={onClickContinue}
                        id="creditContractAgreeToTermsDE"
                        name="creditContractAgreeToTermsDE"
                        disabled={submitting}
                    >
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.agreeToTerms` })}
                    </Button>
                </div>
            </Form>
        );
    }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onClickContinue: (event) => {
            dispatch(submit(CONTRACT_FORM_ID));
        },
        onFormSubmit: (formValues, intl) => {
            return dispatch(submitContractApi(formValues, LOCALE_PREFIX, intl));
        }
    };
};

export const mapStateToProps = state => ({
    formValues: _.get(state, `form.${CONTRACT_FORM_ID}.values`),
    formSyncErrors: getFormSyncErrors(CONTRACT_FORM_ID)(state),
    creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
    cart: _.get(state, 'serverData.cart', {}),
    htmlContract: _.get(state, 'serverData.decisionModel.htmlContract', ''),
    hasSubmitFailed: hasSubmitFailed(CONTRACT_FORM_ID)(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: CONTRACT_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(ContractPageForm)
));
